import i18n, { type TFunction } from 'i18next';
import moment from 'moment';

import type { SkydioFlight } from 'utils/skydio';

export const getMediaKindOptions = (t: TFunction) => [
  { label: t('inspection.skydio.rgbImages', 'RGB images'), value: 'vehicleImage' },
  {
    label: t('inspection.skydio.radiometricImages', 'Radiometric thermal images'),
    value: 'vehicleRadiometricImage',
  },
];

export const mediaKindLabels: Record<string, string> = {
  vehicleImage: 'RGB',
  vehicleRadiometricImage: 'Thermal',
};

export function shortId(id?: string) {
  if (!id) {
    return i18n.t('inspection.skydio.unknownFlight', 'Unknown flight');
  }
  return id.length > 12 ? `${id.slice(0, 6)}...${id.slice(-4)}` : id;
}

export function normalizeFlightId(value: string) {
  const trimmed = value.trim();
  // Skydio Cloud links use dashed UUIDs; the API also returns compact uppercase UUIDs.
  return /^(?:[a-f\d]{32}|[a-f\d]{8}(?:-[a-f\d]{4}){3}-[a-f\d]{12})$/i.test(trimmed)
    ? trimmed.replace(/-/g, '').toUpperCase()
    : trimmed;
}

export function formatCatalogFlightLabel(
  flight: Pick<SkydioFlight, 'flightId' | 'takeoff' | 'landing'>
) {
  if (!flight.takeoff) {
    return shortId(flight.flightId);
  }
  const takeoff = moment(flight.takeoff);
  const landing = flight.landing ? moment(flight.landing) : undefined;
  const timeRange = landing
    ? `${takeoff.format('MMM D, HH:mm')} - ${landing.format('HH:mm')}`
    : takeoff.format('MMM D, HH:mm');
  return `${timeRange} (${shortId(flight.flightId)})`;
}
